var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7626 16.3084H5.23699C4.91397 16.3084 4.60418 16.1801 4.37577 15.9517C4.14736 15.7233 4.01904 15.4135 4.01904 15.0904V4.12891H14.9806V15.0904C14.9806 15.4135 14.8523 15.7233 14.6239 15.9517C14.3954 16.1801 14.0857 16.3084 13.7626 16.3084Z",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6731 12.653V7.78125",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3269 12.653V7.78125",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58325 4.12891H17.4166",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3271 1.69141H7.67327C7.35025 1.69141 7.04046 1.81973 6.81205 2.04814C6.58364 2.27654 6.45532 2.58633 6.45532 2.90936V4.1273H12.5451V2.90936C12.5451 2.58633 12.4167 2.27654 12.1883 2.04814C11.9599 1.81973 11.6501 1.69141 11.3271 1.69141Z",
    stroke: "#7A49B9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBin);
export default __webpack_public_path__ + "static/media/Bin.11583638.svg";
export { ForwardRef as ReactComponent };